<ul class="nav nav-tabs justify-content-start">
    <li *ngIf="hasRole(TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE)" class="nav-item">
      <a class="nav-link" routerLink="consolidado" routerLinkActive="active">Reporte Consolidado</a>
    </li>
    <!--<li *ngIf="hasRole(TipoUsuario.RESPRODUCTO)" class="nav-item">
      <a class="nav-link" routerLink="resolucionMensual" routerLinkActive="active">Resolución Mensual</a>
    </li>-->    
</ul>

<router-outlet></router-outlet>